"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MessageSquare } from "lucide-react";
export default function CallToActionBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="call-to-action-banner" className="dark bg-background text-foreground py-20 px-4 sm:px-8">
      <div ref={ref} className={`max-w-screen-lg mx-auto bg-muted-dark-background rounded-xl px-8 sm:px-16 lg:px-32 py-16 sm:py-20 text-center transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h2 className="text-3xl font-extrabold mb-6 !text-[hsl(35,88%,47%)] sm:text-4xl lg:text-5xl">Butuh Konsultasi Hukum?</h2>
        
        <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto mb-10">Tim kami siap membantu menyelesaikan masalah hukum Anda dengan profesional dan berintegritas</p>

        <Link to="#contact">
          <Button size="lg" className="relative overflow-hidden h-14 px-10 text-base font-bold uppercase tracking-wider shadow-strong hover:shadow-[0_25px_30px_-10px_rgba(253,191,0,0.4)] transition-all duration-[var(--duration-medium)] group">
            <span className="relative z-10 flex items-center gap-3 !text-[hsl(0,0%,0%)]">KONSULTASI SEKARANG</span>
            <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:translate-x-full transition-transform duration-[var(--duration-slow)] ease-linear" aria-hidden="true" />
            <span className="absolute inset-0 animate-[shimmer_3s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" style={{
            backgroundSize: "200% 100%"
          }} aria-hidden="true" />
          </Button>
        </Link>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </section>;
}